var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.506,
    width: 14,
    height: 14,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.905 5.498h1.096V3.59a14.146 14.146 0 0 0-1.596-.084c-1.58 0-2.662.993-2.662 2.82v1.68H6v2.133h1.743v5.367H9.88v-5.367h1.672l.266-2.133H9.88v-1.47c0-.616.166-1.038 1.025-1.038Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .506)",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgIconFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxyZWN0IHg9IjEiIHk9IjEuNTA1ODYiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgcng9IjMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTEwLjkwNSA1LjQ5ODM2SDEyLjAwMDVWMy41OTAzNkMxMS44MTE1IDMuNTY0MzYgMTEuMTYxNSAzLjUwNTg2IDEwLjQwNDUgMy41MDU4NkM4LjgyNSAzLjUwNTg2IDcuNzQzIDQuNDk5MzYgNy43NDMgNi4zMjUzNlY4LjAwNTg2SDZWMTAuMTM4OUg3Ljc0M1YxNS41MDU5SDkuODhWMTAuMTM5NEgxMS41NTI1TDExLjgxOCA4LjAwNjM2SDkuODc5NVY2LjUzNjg2QzkuODggNS45MjAzNiAxMC4wNDYgNS40OTgzNiAxMC45MDUgNS40OTgzNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUwNTg1OSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";